export interface MonumentTranslation {
    id;
    monumentId;
    language;
    name;
    shortDescription;
    description;
    audioPath;
    extraDescription;
}

export interface ComponentConfiguration{
    info;
    gallery;
    threeSixty;
    vr;
    model;
    sharing;
    rating;
}

export class MonumentDto {
    id = null;
    centerImage;
    latitude = 0;
    longitude = 0;
    version = 0;
    siteId = 0;
    extraImage ='';
    componentConfiguration:ComponentConfiguration;
    monumentTranslations: MonumentTranslation[] = [];
    monument_show_index = 1000;
    panoramic;
    panoramicOrientation;
    slides = [];
    seotitle;
    model;
    fbxScale;
    constructor(private idsSite) {
        this.siteId = idsSite;
    }

}